import { shiftPeriod } from './period';
import { trpc } from './trpc';

/**
 * The period a page shows: the one in the URL, else the household's current
 * period (salary-day aware, owned by the server). `ready` turns true once the
 * period is known, or the lookup failed and the calendar month is used instead.
 */
export function useViewPeriod(search: { year?: number | undefined; month?: number | undefined }) {
  const currentQuery = trpc.period.current.useQuery(undefined, { retry: false });
  const now = new Date();
  // A half-specified URL (?year= without month) waits for the server's period
  const hasExplicit = search.year != null && search.month != null;
  const year = search.year ?? currentQuery.data?.year ?? now.getFullYear();
  const month = search.month ?? currentQuery.data?.month ?? now.getMonth() + 1;
  const ready = hasExplicit || currentQuery.isSuccess || currentQuery.isError;
  // One period ahead may be opened, to plan the next month
  const max = currentQuery.data
    ? shiftPeriod(currentQuery.data.year, currentQuery.data.month, 1)
    : undefined;
  const isCurrent =
    currentQuery.data != null &&
    currentQuery.data.year === year &&
    currentQuery.data.month === month;

  return { year, month, ready, max, isCurrent, currentQuery };
}
